import FlexRow from "../../../../components/base/FlexRow"
import Icon from "../../../../components/base/Icon"
import { openJobQuickView, toPrettyDate } from "../../../../core/Global";
import Job from "../../../crm/jobs/models/Job";



interface IProps {
    job: Job
}
export default function JobReportCard(props: IProps) {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    return (
        <div className="card mb-5"
            onClick={e => {
                openJobQuickView(props.job.id)
            }}>
            <div className="card-body">

                <FlexRow className="mb-2">
                    <Icon icon="location-dot" type="solid" className="me-1" />
                    <div className="fs-7">
                        {props.job.address?.title}
                    </div>
                </FlexRow>

                <FlexRow className="mb-2">
                    <Icon icon="clock" type="solid" className="me-1 fs-8" />
                    <div className="fs-7">
                        {toPrettyDate(props.job.lastStatusUpdatedAt)}
                    </div>
                </FlexRow>

                <FlexRow className="mb-2">

                    <FlexRow className="me-5">
                        <div className="me-1 fs-7 fw-bold">
                            Tech Parts:
                        </div>
                        <div className="fs-7">
                            {moneyFormatter.format(props.job.paymentDetails?.techParts ?? 0)}
                        </div>
                    </FlexRow>

                    <FlexRow className="me-5">
                        <div className="me-1 fs-7 fw-bold">
                            Co Parts:
                        </div>
                        <div className="fs-7">
                            {moneyFormatter.format(props.job.paymentDetails?.companyParts ?? 0)}
                        </div>
                    </FlexRow>

                </FlexRow>

                <FlexRow>
                    <FlexRow className="me-5">
                        <div className="me-1 fs-7 fw-bold">
                            Total:
                        </div>
                        <div className="fs-7">
                            {moneyFormatter.format(props.job.payment?.totalPayment ?? 0)}
                        </div>
                    </FlexRow>
                    <FlexRow className="me-5">
                        <div className="me-1 fs-7 fw-bold">
                            Profit:
                        </div>
                        <div className="fs-7">
                            {moneyFormatter.format(props.job.paymentDetails?.techProfit ?? 0)}
                        </div>
                    </FlexRow>

                    <FlexRow className="ms-auto">
                        <div className={!props.job.paymentDetails ? "" : (props.job.paymentDetails?.techBalance ?? 0) < 0 ? "text-danger fs-5 fw-bold" : "text-success fs-5 fw-bold"}>
                            {!props.job.paymentDetails ? "" : (props.job.paymentDetails?.techBalance ?? 0) < 0 ? "" : "+"}
                            {moneyFormatter.format(props.job.paymentDetails?.techBalance ?? 0)}
                        </div>
                    </FlexRow>
                </FlexRow>

            </div>
        </div>
    )
}